import React, {useState} from 'react';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";
import {Link} from "@reach/router";
import FrequentlyTopics from "js/components-v2/pages/BuyerPage/steps/FrequentlyTopics";
import userCountry from 'js/services/UserCountry';
import Features from 'js/components-v2/pages/BuyerPage/features/Features';
import FeaturesNG from 'js/components-v2/pages/BuyerPage/features/FeaturesNG';
import HowItWorks from 'js/components-v2/pages/BuyerPage/how/HowItworks';
import HowItworksNG from 'js/components-v2/pages/BuyerPage/how/HowItworksNG';
import BetterExperience from 'js/components-v2/pages/BuyerPage/experience/BetterExperience';
import BetterExperienceNG from 'js/components-v2/pages/BuyerPage/experience/BetterExperienceNG';

const BuyerTabs = () => {
  const [active, setActive] = useState('features');

  const handleClick = (index) => {
    setActive(index);
  }

  const buttonBuyingFaster = <Link to={'/buyer-signup'} className="btn btn-pod btn-primary d-none d-md-block">
    {userCountry() !== 'NG' ? 'Start buying faster' : 'Start buying securely'}
  </Link>;

  return (
    <div className="buyer-tabs pod-container">
      <div className="menu">
        <div className="tabs justify-content-md-center">
          <a href="#key-features" className={`btn btn-tab ${active === 'features' ? 'active' : null}`} onClick={() => handleClick('features')}>
            Key Features
          </a>
          <a href="#how-it-works" className={`btn btn-tab ${active === 'how' ? 'active' : null}`} onClick={() => handleClick('how')}>
            How it works?
          </a>
          <a href="#frequent-topics" className={`btn btn-tab ${active === 'frequently' ? 'active' : null}`} onClick={() => handleClick('frequently')}>
            Frequently looked up topics
          </a>
        </div>
      </div>

      <div className="content">
        {userCountry() !== 'NG' ? <Features active={active} /> : <FeaturesNG active={active} />}

        <div className={`tab-content how-it-works ${active === 'how' ? 'active' : null}`} id="how-it-works">
          <h3 className="title">How it works?</h3>
          <p className="intro-text">Get it done in 3 steps</p>

          <div className="steps">
            {userCountry() !== 'NG' ? (
              <>
                <HowItWorks buttonBuyingFaster={buttonBuyingFaster} />
                <BetterExperience />
              </>
            ) : (
              <>
                <HowItworksNG buttonBuyingFaster={buttonBuyingFaster} />
                <BetterExperienceNG />
              </>
            )}
            <FrequentlyTopics/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuyerTabs;
